import { Button } from "@/components/ui/button";
import Section from "@/components/Section";
import rocketImage from "@/assets/raket-1000px.jpg";

const AILyftet = () => {
  return (
    <Section
      surface="alt"
      eyebrow="National initiative"
      title={<>AI-<span className="text-gradient-brand">Lyftet</span></>}
      description="Building AI capability across Swedish organizations and society."
    >
      <div className="grid md:grid-cols-2 gap-8 lg:gap-12 items-center">
        <div className="relative order-2 md:order-1">
          <div className="absolute -inset-2 bg-gradient-brand opacity-20 blur-2xl rounded-2xl" aria-hidden />
          <img
            src={rocketImage}
            alt="AI-Lyftet rocket launch visualization"
            className="relative w-full h-auto rounded-2xl border border-border/60"
          />
        </div>

        <div className="space-y-6 order-1 md:order-2">
          <div className="space-y-4 text-muted-foreground text-lg leading-relaxed">
            <p>
              AI-Lyftet is an initiative designed to improve AI skills among Swedish companies and society. Its goal is to enhance decision-making, boost efficiency, and drive innovation through AI knowledge. The program is tailored for leadership teams, AI managers, and IT or HR leaders, helping organizations create customized training plans for all employees and leaders.
            </p>
            <p>
              Through workshops, AI-Lyftet provides essential AI knowledge, enabling employees to get started and laying the groundwork for AI transformation. It includes practical educational activities such as courses, seminars, digital forums, leader workshops, webinars, promptathons, hackathons, and other events. The initiative also focuses on understanding the ethical dimensions of AI and promoting responsible use.
            </p>
          </div>

          <a href="https://ai-lyftet.se/" target="_blank" rel="noopener noreferrer">
            <Button variant="secondary" size="lg" className="mt-2">
              Read more →
            </Button>
          </a>
        </div>
      </div>
    </Section>
  );
};

export default AILyftet;
